import { PayeeEngagementType } from "@wingspanhq/wingspan-api-sdk";

/**
 * What to call the person on the other side of a work log.
 *
 * The design's W-2 copy says "employee" ("the employee wasn't paid for it",
 * "inform your employee about the decision") while the 1099 copy says
 * "contractor" — the same distinction the resource noun follows, applied to the
 * person instead of the payment.
 *
 * Defaults to "contractor", which is both the 1099 term and the safe fallback
 * for an engagement whose type has not resolved. On contractor-facing work-log
 * surfaces the type never resolves at all, so they always read "contractor" —
 * WIN-16077.
 */
export const selectorWorkLogWorkerNoun = (
  engagementType: PayeeEngagementType | null | undefined
): string =>
  engagementType === PayeeEngagementType.EMPLOYEE ? "employee" : "contractor";
